module.exports = __webpack_public_path__ + "media/images/menu/octans-da580748d347fb103964e12f5250c30a.jpg";